import React from 'react';

// These SVGs are designed to look like rough charcoal sketches
// Non-functional, purely aesthetic

export const CharcoalUnderline: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 200 20" className={className} preserveAspectRatio="none">
    <path
      d="M5,15 Q50,5 100,12 T195,8"
      fill="none"
      stroke="#595856"
      strokeWidth="2"
      strokeLinecap="round"
      style={{ opacity: 0.6 }}
    />
  </svg>
);

export const CharcoalStar: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 40 40" className={className}>
    <path
      d="M20,5 L23,15 L35,15 L25,22 L28,33 L20,26 L12,33 L15,22 L5,15 L17,15 Z"
      fill="none"
      stroke="#2A2A29"
      strokeWidth="1.5"
      strokeLinejoin="round"
      strokeLinecap="round"
      style={{ opacity: 0.8 }}
    />
    {/* Scribble fill effect */}
    <path
      d="M18,18 L22,20 M19,22 L23,18"
      stroke="#ABAAA6"
      strokeWidth="1"
    />
  </svg>
);

export const CharcoalSwirl: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 50 50" className={className}>
    <path
      d="M10,40 C10,10 40,10 40,40"
      fill="none"
      stroke="#FF596C"
      strokeWidth="2"
      strokeLinecap="round"
      style={{ opacity: 0.5 }}
      strokeDasharray="4 2"
    />
  </svg>
);

export const CharcoalArrow: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 60 40" className={className}>
    <path
      d="M10,20 Q30,15 50,20 M40,10 L50,20 L42,30"
      fill="none"
      stroke="#2A2A29"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CharcoalComment: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 50 50" className={className}>
    <path
      d="M10,10 C8,10 5,12 5,15 L5,35 C5,38 8,40 10,40 L15,40 L15,48 L25,40 L40,40 C42,40 45,38 45,35 L45,15 C45,12 42,10 40,10 Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15,22 L35,22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15,29 L30,29"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
